import { Injectable } from '@angular/core';
import { IAuthService } from '../interfaces/auth.service.interface';
// import { IAuthService } from '../interfaces/auth.service.interface';

@Injectable({ providedIn: 'root' })
export abstract class AuthServiceBase implements IAuthService {
  public abstract isAuthenticated(): boolean;
}
